import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import { createApp } from "vue";  // ✅ Vérifier cet import
import App from "./App.vue";
import router from "./router"; // ✅ Assure-toi que router.js est correct

const app = createApp(App);
app.use(router); // ✅ Utilisation correcte du router
app.mount("#app");
console.log("🛠️ Chargement des variables :", import.meta.env);
